import {
  SET_KEYWORDS_PER_ENTITY,
  SET_SELECTED_ENTITY_DETAILS,
  SET_ENTITY_DETAILS,
  SET_ENTIIY_DETAILS_START,
  SET_ENTITY_DETAILS_FAILED,
  SET_PARENT_CLIENT_ID,
  SET_FETCH_SOCIAL_ENTITY_FINISH,
  SET_CONFIGURATION,
} from "../actions/actionTypes";

const initialState = {
  keyWordsPerEntity: [],
  entityDetails: {
    entityList: [],
    isLoading: true,
    error: undefined,
  },
  selectedEntity: {},
  configuration: {
    configuration: {},
    isLoading: {},
  },
  parentClientId: null,
};

export const entityAndKeyWordsReducer = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case SET_KEYWORDS_PER_ENTITY:
      return { ...state, keyWordsPerEntity: payload };
    case SET_ENTIIY_DETAILS_START:
      return {
        ...state,
        entityDetails: {
          isLoading: true,
        },
      };

    case SET_ENTITY_DETAILS:
      return {
        ...state,
        entityDetails: { entityList: payload, isLoading: false },
      };
    case SET_CONFIGURATION:
      return {
        ...state,
        configuration: { configuration: payload, isLoading: false },
      };
    case SET_ENTITY_DETAILS_FAILED:
      return {
        ...state,
        entityDetails: {
          error: payload,
          isLoading: false,
        },
      };

    case SET_SELECTED_ENTITY_DETAILS:
      return { ...state, selectedEntity: payload };

    case SET_PARENT_CLIENT_ID:
      return { ...state, parentClientId: payload };

    case SET_FETCH_SOCIAL_ENTITY_FINISH:
      return {
        ...state,
        socialEntityList: payload,
        isLoading: false,
      };

    default:
      return state;
  }
};
